module.exports = __webpack_public_path__ + "static/media/intro-aio.178c0ede.jpg";